import { Component, OnInit, OnDestroy } from '@angular/core';
import { LiveRecordingsService } from 'src/app/services/live-recordings/live-recordings.service';
import { LiveRecording, Paginated, RecordingStatus } from 'src/app/models/live-recording.model';
import { environment } from 'src/environments/environment.prod';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { RecordingTrimComponent } from "./recording-trim/recording-trim.component";

@Component({
  selector: 'app-live-recordings',
  imports: [CommonModule, FormsModule, RecordingTrimComponent],
  templateUrl: './live-recordings.component.html',
  styleUrls: ['./live-recordings.component.css']
})
export class LiveRecordingsComponent implements OnInit, OnDestroy {
  private liveStatusTimer: any = null;
  loading = false;
  items: LiveRecording[] = [];

  page = 1;
  lastPage = 1;
  total = 0;

  status: RecordingStatus | '' = '';
  visible: '' | 0 | 1 = '';

  // MP4 URL ასაწყობად:
  // თუ mp4_path DB-ში ინახება როგორც აბსოლუტური /opt/streaming/... მაშინ ჯობია API დაგიბრუნოს public url.
  // მაგრამ დროებით თუ შენ storage-ს გაძლევს URL-ებს, აქ ჩაასწორებ.
  publicBase = 'https://live.sca.ge'; // ან environment.liveBaseUrl
  private recordingsApiBase = 'https://api.sca.ge/api/admin/live-recordings';

  selected?: LiveRecording;
  selectedTrimItem?: LiveRecording;
  selectedTitleItem: any = null;


  liveStatus: any = null;

  liveMetaForm = {
    stream_key: '',
    title_ka: '',
    title_en: ''
  };


  openTitleEditor(item: LiveRecording) {
    this.selectedTitleItem = {
      ...item,
      title: (item as any).title || '',
      title_en: (item as any).title_en || ''
    };
  }

  toggleTrim(item: LiveRecording) {
    this.selectedTrimItem = this.selectedTrimItem?.id === item.id ? undefined : item;
  }



  constructor(private recService: LiveRecordingsService, private http: HttpClient, private ToastrService: ToastrService) {}

  ngOnInit(): void {
    this.fetch(1);
    this.startLiveStatusPolling();
    this.loadLiveStatus();
  }

  ngOnDestroy(): void {
    this.stopLiveStatusPolling();
  }



  fetch(page: number) {
    this.loading = true;
    this.recService.list({ page, status: this.status, visible: this.visible }).subscribe({
      next: (res: Paginated<LiveRecording>) => {
        this.items = res.data || [];
        this.page = res.current_page;
        this.lastPage = res.last_page;
        this.total = res.total;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  applyFilters() {
    this.fetch(1);
  }

  clearFilters() {
    this.status = '';
    this.visible = '';
    this.fetch(1);
  }

  statusBadgeClass(s: RecordingStatus) {
    switch (s) {
      case 'ready': return 'badge bg-success';
      case 'processing': return 'badge bg-warning text-dark';
      case 'recorded': return 'badge bg-secondary';
      case 'failed': return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  }

  bytesToMb(bytes?: number | null): string {
    if (!bytes || bytes <= 0) return '-';
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(mb >= 10 ? 0 : 1)} MB`;
  }

  // ⚠️ იდეალურად backend-მა უნდა დაგიბრუნოს mp4_url.
  // აქ დროებით ვაკეთებთ ჰაკს: mp4_path თუ არის "recordings/xxx.mp4" ან "/recordings/xxx.mp4"
  // შენს მიხედვით ჩაასწორე.
  mp4Url(item: LiveRecording): string | null {
    const p = item.mp4_path;
    if (!p) return null;

    // თუ შენ ინახავ "/opt/streaming/recordings/xxx.mp4"
    // და live.sca.ge ემსახურება /recordings/xxx.mp4, მაშინ:
    const idx = p.indexOf('/recordings/');
    if (idx >= 0) {
      return `${this.publicBase}${p.substring(idx)}`; // https://live.sca.ge/recordings/xxx.mp4
    }

    // თუ უკვე public pathაა:
    if (p.startsWith('/recordings/')) return `${this.publicBase}${p}`;
    if (p.startsWith('http')) return p;

    // თუ relativeა:
    return `${this.publicBase}/${p.replace(/^\/+/, '')}`;
  }

  openPlayer(item: LiveRecording) {
    this.selected = item;
  }

  closePlayer() {
    this.selected = undefined;
  }

  deleteRecording(item: LiveRecording) {
    if (!item?.id) return;

    const ok = confirm(`ნამდვილად გსურთ ჩანაწერის წაშლა? (#${item.id})`);
    if (!ok) return;

    this.http.delete<any>(`${this.recordingsApiBase}/${item.id}`).subscribe({
      next: () => {
        this.ToastrService.success('ჩანაწერი წარმატებით წაიშალა');

        if (this.selected?.id === item.id) {
          this.selected = undefined;
        }

        const nextPage = this.items.length === 1 && this.page > 1 ? this.page - 1 : this.page;
        this.fetch(nextPage);
      },
      error: (err) => {
        console.error(err);
        this.ToastrService.error('ჩანაწერის წაშლა ვერ მოხერხდა');
      }
    });
  }




  loadLiveStatus() {
      // this.http.get<any>('https://api.sca.ge/api/live/status').subscribe({
      //   next: (res) => {
      //     this.liveStatus = res;

      //     if (res?.is_live && res?.stream) {
      //       this.liveMetaForm.stream_key = res.stream;
      //       this.liveMetaForm.title_ka = res.title_ka || '';
      //       this.liveMetaForm.title_en = res.title_en || '';
      //     }
      //   },
      //   error: (err) => {
      //     console.error(err);
      //   }
      // });
  }
getFilename(item: any): string {
  if (!item?.mp4_path) return '';
  return item.mp4_path.split('/').pop();
}
  saveLiveMeta() {
    this.http.post<any>('https://api.sca.ge/api/admin/live-meta/save', this.liveMetaForm).subscribe({
      next: (res) => {
        // console.log('saved', res);
        this.ToastrService.success('ლაივის სათაური წარმატებით შეინახა')
        this.loadLiveStatus();
      },
      error: (err) => {
        console.error(err);
                this.ToastrService.error('მოხდა შეცდომა სცადეთ თავიდან')

      }
    });
  }
  startLiveStatusPolling(): void {
    this.stopLiveStatusPolling();
    this.loadLiveStatus();
    this.liveStatusTimer = setInterval(() => {
      this.loadLiveStatus();
    }, 10000);
  }

  stopLiveStatusPolling(): void {
    if (this.liveStatusTimer) {
      clearInterval(this.liveStatusTimer);
      this.liveStatusTimer = null;
    }
  }

  saveRecordingTitle() {
    if (!this.selectedTitleItem?.id) return;

    this.recService.updateRecordingTitle(this.selectedTitleItem.id, {
      title: this.selectedTitleItem.title || '',
      title_en: this.selectedTitleItem.title_en || ''
    }).subscribe({
      next: (res) => {
        const index = this.items.findIndex((x: any) => x.id === this.selectedTitleItem.id);
        if (index > -1) {
          this.items[index] = {
            ...this.items[index],
            ...(res.item || {})
          } as LiveRecording;
        }
        this.ToastrService.success('სათაური წარმატებით შეინახა');
        this.selectedTitleItem = null;
      },
      error: (err) => {
        console.error(err);
        this.ToastrService.error('სათაურის შენახვა ვერ მოხერხდა');
      }
    });
  }






}